// extracted by mini-css-extract-plugin
module.exports = {"container":"FolderView_container__2EUYW","item":"FolderView_item__F-LJv","icon":"FolderView_icon__1M9FZ","folder":"FolderView_folder__2BqmT"};